import script from "./editTestConfig.vue?vue&type=script&lang=ts&setup=true"
export * from "./editTestConfig.vue?vue&type=script&lang=ts&setup=true"

import "./editTestConfig.vue?vue&type=style&index=0&id=57a3ce3e&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57a3ce3e"]])

export default __exports__